import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { Link } from '../../../../../components/Wrappers/Wrappers.jsx';
import { DefaultURLs } from '../../../../../utils/constants';
import { useStyles } from '../styles';

function BillingStatusNotice(props) {
    const {
        showBilling,
        showAwsBillingInfo,
        showBillingAlt,
        // isFreeOrTrialPlan,
        supportLabel,
        onContactClick,
    } = props;

    const classes = useStyles();

    return (
        <React.Fragment>
            {showBilling && (
                <Typography
                    variant={'body2'}
                    weight={'light'}
                    style={{ marginBottom: 12 }}
                >
                    By using ECAL services without a custom contract, you agree that your account is governed by the online{' '}
                    <strong>
                        <Link
                            href={DefaultURLs.SAAS_TERMS}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="always"
                        >
                            ECAL Licence Terms
                        </Link>
                    </strong>.
                </Typography>
            )}

            {showAwsBillingInfo && (
                <Typography
                    variant={'body2'}
                    weight={'light'}
                    style={{ marginBottom: 12 }}
                >
                    You are on an AWS Marketplace Contract.<br/>
                    <strong>Please contact </strong><u><Link className={classes.linkPointer} onClick={onContactClick}>{supportLabel}</Link></u> to upgrade or make changes to your plan.
                </Typography>
            )}

            {showBillingAlt && (
                <Typography
                    variant={'body2'}
                    weight={'light'}
                    style={{ marginBottom: 12 }}
                >
                    <strong>Please contact </strong><u><Link className={classes.linkPointer} onClick={onContactClick}>{supportLabel}</Link></u> to upgrade or make changes to your plan.
                </Typography>
            )}

            {showBillingAlt && (
                <Typography
                    variant={'body2'}
                    weight={'light'}
                    style={{ marginBottom: 30 }}
                >
                    By using ECAL services without a custom contract, you agree that your account is governed by the online{' '}
                    <strong>
                        <Link
                            href={DefaultURLs.SAAS_TERMS}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="always"
                        >
                            ECAL Licence Terms
                        </Link>
                    </strong>.
                </Typography>
            )}
        </React.Fragment>
    );
}

BillingStatusNotice.propTypes = {
    showBilling: PropTypes.bool,
    showAwsBillingInfo: PropTypes.bool,
    showBillingAlt: PropTypes.bool,
    isFreeOrTrialPlan: PropTypes.bool,
    supportLabel: PropTypes.string,
    onContactClick: PropTypes.func,
};

BillingStatusNotice.defaultProps = {
    showBilling: false,
    showAwsBillingInfo: false,
    showBillingAlt: false,
    isFreeOrTrialPlan: false,
    supportLabel: '',
    onContactClick: () => {},
};

export default BillingStatusNotice;
